#indicators-of-risk-content {
  width: 70%;

  #indicators-of-risk-info-text {
    color: var(--body-text-arrows-400);
  }

  #indicators-of-risk-info-link {
    margin-left: -2px;
  }

  #policy-panel-scheduler-start-date-and-time-form-field {
    margin-top: calc(var(--spacer) * 1.5);
    display: flex;

    #policy-panel-scheduler-start-date-form-field {
      margin-right: calc(2 * var(--spacer));
    }
  }

  #policy-panel-recurrence {
    display: block;
  }

  #policy-panel-recurrence-run-every {
    margin-right: calc(2 * var(--spacer));
  }
}

.form-section {
  width: 100%;
  height: auto;
  display: flex;
  margin-top: calc(var(--spacer) * 2.5);
  flex-direction: column;
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 2.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

.form-field-label {
  width: var(--form-field-label-width);
  font-size: var(--body-size);
  padding-top: var(--spacer);
  display: inline-table;
}

gz-form-field {
  &#policy-panel-recurrence-run-per,
  &#policy-panel-recurrence-run-every,
  &#policy-panel-recurrence-weekdays-run-every {
    --margin-bottom-wrapper: var(--spacer);
  }
}

.radio {
  display: flex;
  align-items: center;
}

gz-radio {
  margin-right: calc(2 * var(--spacer));
  &#policy-panel-recurrence-schedule-radio {
    width: calc(250px - calc(7 * var(--spacer)));
  }
  &#policy-panel-recurrence-weekdays-radio {
    min-width: 194px;
    margin-bottom: calc(var(--spacer) * 2);
  }
}

gz-dropdown.small-dropdown {
  --form-field-input-width: 160px;
}
